// extracted by mini-css-extract-plugin
export default {"actions":"SMLPageActions_actions__It5mi","secondary":"SMLPageActions_secondary__x93ck","primary":"SMLPageActions_primary__w9cO6"};